import React from "react";
import ReactApexChart from "react-apexcharts";

const FacultyStudentRatioChart = ({ data = [], categories = [] }) => {
  const series = [
    {
      name: "نسبة هيئة التدريس إلى الطلاب",
      data: data, // مثال: [4.18, 1.61]
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "13%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(2)} : 1`,
      style: {
        fontSize: "12px",
        fontFamily: "Cairo",
      },
    },
    colors: ["#f39c12"],
    xaxis: {
      categories: categories,
      title: {
        text: "الجامعة",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      title: {
        // text: "النسبة (عدد الهيئة : 1 طالب)",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        formatter: (val) => `${val.toFixed(1)}`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)} عضو لكل طالب`,
      },
    },
    legend: {
      show: false,
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3">مقارنة بين الجامعات حسب نسبة هيئة التدريس إلى الطلاب</h5>
      <ReactApexChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default FacultyStudentRatioChart;
